import React from 'react';
import './MdxParagraph.scss';

const MdxParagraph = (props: any) => {
  // eslint-disable-next-line react/destructuring-assignment
  return <div className="paragraph">{props.children}</div>;
};

export default MdxParagraph;
